import supabase from '../supabase/supabase';

class TransferMatchingService {
  async detectMatches(accountId, toleranceDays = 3) {
    if (!accountId) return [];

    const { data, error } = await supabase.rpc(
      'detect_transfer_matches_1788210000000',
      {
        p_account_id: accountId,
        p_tolerance_days: toleranceDays
      }
    );

    if (error) {
      console.error('Transfer matching failed:', error);
      throw error;
    }

    return data || [];
  }

  async confirmMatch(matchId) {
    const { data, error } = await supabase.rpc('confirm_transfer_match', {
      p_match_id: matchId
    });

    if (error) {
      console.error('Confirm transfer match failed:', error);
      throw error;
    }

    return data;
  }

  async ignoreMatch(matchId) {
    const { data, error } = await supabase.rpc('ignore_transfer_match', {
      p_match_id: matchId
    });

    if (error) {
      console.error('Ignore transfer match failed:', error);
      throw error;
    }

    return data;
  }
}

export const transferMatchingService = new TransferMatchingService();